// ============================================
// COMPONENT - Tile de KPI compartido entre las pantallas de Caja 360
// ============================================
import { Card, CardContent } from '@almacenes/ui';

interface KpiTileProps {
  label: string;
  value: string;
  highlight?: boolean;
  /** 'card' (default): Card/CardContent con texto grande — MiCajaPage. 'compact': recuadro chico — modales de detalle. */
  variant?: 'card' | 'compact';
}

export const KpiTile = ({ label, value, highlight, variant = 'card' }: KpiTileProps) => {
  const valueClass = variant === 'compact'
    ? `mt-1 text-lg font-black ${highlight ? '' : 'text-gray-900'}`
    : `mt-1 text-2xl font-black ${highlight ? '' : 'text-gray-900'}`;
  const valueStyle = highlight ? { color: '#22C55E' } : undefined;

  if (variant === 'compact') {
    return (
      <div className="bg-gray-50 rounded-lg p-3">
        <p className="text-xs font-semibold text-gray-600">{label}</p>
        <p className={valueClass} style={valueStyle}>{value}</p>
      </div>
    );
  }

  return (
    <Card>
      <CardContent>
        <p className="text-sm font-semibold text-gray-600">{label}</p>
        <p className={valueClass} style={valueStyle}>{value}</p>
      </CardContent>
    </Card>
  );
};
